export default __webpack_public_path__ + "c12cec6ca4973aa49e17e37a6743b285.svg";